import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AlertService } from '@app/core';
import { Attachment } from '@app/core/models';
import { AttachmentService } from '@app/core/services/attachment.service';
import { ModalFileViewerComponent } from '@app/modules/eclass/components/modal-file-viewer/modal-file-viewer.component';
import { SHARED_MODULES } from '@app/shared';
import { TextEditorComponent } from '@app/shared/modules/text-editor/text-editor.component';
import { safeEmpty } from '@app/shared/utils';

@Component({
  selector: 'app-sidenav-answer',
  imports: [SHARED_MODULES, TextEditorComponent],
  templateUrl: './sidenav-answer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavAnswerComponent {
  public readonly dialogRef = inject<DialogRef<string>>(DialogRef);
  private readonly _alertService = inject(AlertService);
  private readonly _attachmentService = inject(AttachmentService);
  private readonly _dialog = inject(Dialog);
  @Input() public data: any;
  public load = true;

  public removeHTMLTags(htmlString: string): string {
    const cleanedText = new DOMParser().parseFromString(htmlString, 'text/html').body.textContent || '';
    return cleanedText;
  }

  public icon(extension): string {
    return '/assets/images/files/' + extension + '.svg';
  }

  public onOpenFeedbackAttachment(attachment: Attachment) {
    this._dialog.open(ModalFileViewerComponent, {
      data: {
        title: attachment?.title,
        url: attachment?.url || attachment?.file,
        type: attachment?.type ?? null,
        file: attachment?.file,
      },
    });
  }

  public canDownload(extension: string) {
    const ext = ['pdf', 'jpg', 'jpeg', 'xls', 'xlsx', 'ppt', 'pptx', 'doc', 'docx', 'png'];

    return ext.includes(extension);
  }

  public onDownload(attachmentId: number): void {
    this._attachmentService
      .getPresignedDownloadUrl(attachmentId)
      .pipe(safeEmpty())
      .subscribe({
        next: ({ download_url, title }) => {
          const a = document.createElement('a');
          a.href = download_url;
          a.download = title;
          a.click();
        },
        error: () => this._alertService.alert({ message: 'geral.erro-download' }),
      });
  }
}
